import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {getMenuList} from "./Components/index";
import {NavLink} from "react-router-dom";
import {setMenu} from "../../Components/bodySlice";

function Menus(props) {
    const dispatch = useDispatch();
    const [dataMenus, setDataMenus] = useState([]);

    useEffect(() => {
        getMenus()
    }, []);

    const getMenus = async () => {
        let result = await getMenuList();
        dispatch(setMenu(result));
        setDataMenus(result);
    }

    const renderItem = () => {
        return dataMenus.map(item => {
            return (
                <div className="col-sm-4" key={"menu-list" + item.id}>
                    <h2 className={`h-top`}>
                        <NavLink to={`/categorices/${item.alias}`} title={item.title}>
                            {item.title}
                        </NavLink>
                    </h2>
                </div>
            )
        });
    }

    return (
        <div className="categories-wrapper">
            <div className="row">
                {renderItem()}
                <div className="clearfix"></div>
            </div>
        </div>
    )
}

export default Menus;
